(() => {
  // Qty +/- on PDP cart-style cross-sell cards (same behavior as cart-cross-sells.js).
  function bindQty(root) {
    root.querySelectorAll('[data-pdp-cross-sell-qty]').forEach((qty) => {
      if (qty.dataset.bound === '1') return;
      qty.dataset.bound = '1';
      const input = qty.querySelector('input');
      const minus = qty.querySelector('.qty-minus');
      const plus = qty.querySelector('.qty-plus');
      if (!input || !minus || !plus) return;

      const sync = () => {
        let value = Number(input.value);
        if (!Number.isFinite(value) || value < 1) value = 1;
        value = Math.min(99, Math.floor(value));
        input.value = String(value);
        minus.disabled = value <= 1;
        plus.disabled = value >= 99;
      };

      minus.addEventListener('click', (e) => {
        e.preventDefault();
        input.stepDown();
        sync();
      });
      plus.addEventListener('click', (e) => {
        e.preventDefault();
        input.stepUp();
        sync();
      });
      input.addEventListener('change', sync);
      input.addEventListener('blur', sync);
      sync();
    });
  }

  function stepWidth(track) {
    const card = track.querySelector('.cart-cross-sell-card');
    if (!card) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    // Advance by one card so the pair slides over one-by-one.
    return card.getBoundingClientRect().width + gap;
  }

  function updateNav(carousel) {
    const track = carousel.querySelector('[data-pdp-cross-sell-track]');
    const prev = carousel.querySelector('[data-pdp-cross-sell-prev]');
    const next = carousel.querySelector('[data-pdp-cross-sell-next]');
    if (!track || !prev || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 1);
    const canScroll = maxScroll > 2;
    carousel.dataset.canScroll = canScroll ? '1' : '0';

    if (!canScroll) {
      prev.disabled = true;
      next.disabled = true;
      prev.setAttribute('aria-disabled', 'true');
      next.setAttribute('aria-disabled', 'true');
      return;
    }

    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll;
    prev.disabled = atStart;
    next.disabled = atEnd;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function bindCarousel(root) {
    root.querySelectorAll('[data-pdp-cross-sell-carousel]').forEach((carousel) => {
      if (carousel.dataset.bound === '1') return;
      carousel.dataset.bound = '1';

      const track = carousel.querySelector('[data-pdp-cross-sell-track]');
      const prev = carousel.querySelector('[data-pdp-cross-sell-prev]');
      const next = carousel.querySelector('[data-pdp-cross-sell-next]');
      if (!track || !prev || !next) return;

      const go = (dir) => {
        const delta = stepWidth(track) * dir;
        track.scrollBy({ left: delta, behavior: 'smooth' });
        // update after scroll settles a bit
        window.setTimeout(() => updateNav(carousel), 280);
      };

      prev.addEventListener('click', (e) => {
        e.preventDefault();
        go(-1);
      });
      next.addEventListener('click', (e) => {
        e.preventDefault();
        go(1);
      });

      track.addEventListener(
        'scroll',
        () => {
          updateNav(carousel);
        },
        { passive: true }
      );

      // Keep vertical page scroll when the pointer is over the strip.
      // (Horizontal overflow + scroll-snap was stealing trackpad deltas.)
      track.addEventListener(
        'wheel',
        (e) => {
          if (e.shiftKey) return;
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          if (track.scrollWidth <= track.clientWidth + 2) return;
          // Convert vertical intent into page scroll; block sideways drag.
          e.preventDefault();
          window.scrollBy({ top: e.deltaY, left: 0, behavior: 'auto' });
        },
        { passive: false }
      );

      window.addEventListener('resize', () => updateNav(carousel), { passive: true });
      // Double-rAF so layout is final after gallery host move.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => updateNav(carousel));
      });
    });
  }

  function init(root) {
    const scope = root || document;
    bindQty(scope);
    bindCarousel(scope);
  }

  function initRelatedProducts() {
    const sections = document.querySelectorAll('.shopify-section-pdp-similar-items');
    if (!sections.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      sections.forEach((section) => init(section));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          init(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '16px 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProducts);
  } else {
    initRelatedProducts();
  }
})();
